/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function (cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
  //console.log(cart);
};

ShopifyAPI.updateCartNote = function (note, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/update.js',
      data: 'note=' + attributeToString(note),
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeUpdateCartNote.ajaxCart', note);
      },
      success: function (cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
        else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {
        $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};

ShopifyAPI.onError = function (XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    alert(data.message + '(' + data.status + '): ' + data.description);
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/

let productKey = "";
let variantProducts = [];

ShopifyAPI.addItemFromForm = function (form, callback, errorCallback) {
  const $form = jQuery("#" + form.getAttribute("id"))
  const formData = $form.serializeArray()
  const dataJson = $form.serialize()
  const id = formData.find(item => item.name === 'id').value
  let qty = parseInt(formData.find(item => item.name === 'quantity').value)
  const max = ajaxCart.getMaxQty(id)
  if(max <= 0) {
    ajaxCart.showMaximumMessage($form,'The maximum purchasable quantity is 100')
    return
  }
  if (qty > max) qty = max

  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/add.js',
      data: `id=${id}&quantity=${qty}`,
      dataType: 'json',
      beforeSend: function (jqxhr, settings) {
        $body.trigger('beforeAddItem.ajaxCart', form);
      },
      success: function (line_item) {
        window.dataLayer = window.dataLayer || [];
        dataLayer.push({ ecommerce: null });
        dataLayer.push({
          'event': 'addToCart',
          'ecommerce': {
            'currencyCode': Shopify.currency.active,
            'add': {
              'products': [{
                'name': line_item.title,
                'id': line_item.id,
                'price': line_item.price / 100,
                'brand': line_item.vendor,
                'category': window.collection
                    ? window.collection.title
                    : window.item && window.item.Categories
                    ? window.item.Categories[0]
                    : '',
                'variant': line_item.variant_title ? line_item.variant_title : '',
                'quantity': formData.filter((item)=> item.name === 'quantity')
                            ? parseInt(formData.filter((item)=> item.name === 'quantity')[0].value)
                            : 1
              }]
            }
          }
        });

        if ((typeof callback) === 'function') {
          callback(line_item, form);
        }
        else {
          ShopifyAPI.onItemAdded(line_item, form);
        }
        $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
      },
      error: function (XMLHttpRequest, textStatus) {
        if(XMLHttpRequest.responseJSON.status === 422) {
          ajaxCart.showMaximumMessage($form,'You exceeded the limit for this product.')
        }
        if ((typeof errorCallback) === 'function') {
          errorCallback(XMLHttpRequest, textStatus);
        }
        else {
          ShopifyAPI.onError(XMLHttpRequest, textStatus);
        }
        $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      },
      complete: function (jqxhr, text) {
        if(text !== 'error') $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
      }
    };
  jQuery.ajax(params);
};


// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function (callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if ((typeof callback) === 'function') {
      callback(cart);
    } else {
      ShopifyAPI.onCartUpdate(cart);
    }
    if (typeof (sisCartCheckout) !== 'undefined') {
      sisCartCheckout.refreshCart(cart)
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItemCart = function (line, quantity, id, quantityInitial, minus, callback) {
  var $body = $(document.body),
    params = {
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=' + quantity + '&line=' + line,
      dataType: 'json',
      beforeSend: function () {
        $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
      },
      success: async function (cart) {
        if ((typeof callback) === 'function') {
          callback(cart);
        }
        else {
          ShopifyAPI.onCartUpdate(cart);
        }
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      },
      error: function (XMLHttpRequest, textStatus) {

        // $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
        // ShopifyAPI.onError(XMLHttpRequest, textStatus);
        ajaxCart.showMaximumMessage($(`[data-line=${line}]`),'You exceeded the limit for this product.')
        callback(theme.cartJson);
      },
      complete: function (jqxhr, text) {
        $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
      }
    };

  jQuery.ajax(params);
};

// ---------------------------------------------------------
// POST to cart/update.js returns the cart in JSON.
// To clear a particular attribute, set its value to an empty string.
// Receives attributes as a hash or array. Look at comments below.
// eg. "attributes[fizz]=buzz"
// ---------------------------------------------------------
ShopifyAPI.updateCartAttributes = function (data, callback) {
  var params = {
    type: 'POST',
    url: '/cart/update.js',
    data: data,
    dataType: 'json',
    success: function (cart) {
      if ((typeof callback) === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
    },
    error: function (XMLHttpRequest, textStatus) {
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};


/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function (module, $) {

  'use strict';

  // Public functions
  var init, loadCart;

  // Private general variables
  var settings, isUpdating, $body;

  // Private plugin variables
  var $formContainer, $addToCart, $cartCountSelector, $cartCostSelector, $cartContainer, $drawerContainer, $emptySelector, $triggerSelector;

  // Private functions
  var updateCountPrice, formOverride, itemAddedCallback, itemErrorCallback, cartUpdateCallback, buildCart, cartCallback, getCompareAtPrice, adjustCart, adjustCartCallback, createQtySelectors, qtySelectors, validateQty,showMaximumMessage,getMaxQty,getQtyAdded;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {

    // Default settings
    settings = {
      formSelector: 'form[action^="/cart/add"]',
      cartContainer: '.ajaxcart__container',
      addToCartSelector: 'input[type="submit"], button[type="submit"]',
      cartCountSelector: null,
      cartCostSelector: null,
      triggerSelector: null,
      emptySelector: null,
      moneyFormat: '${{amount}}',
      disableAjaxCart: false,
      enableQtySelectors: true
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer = $(settings.formSelector);
    $cartContainer = $(settings.cartContainer);
    $addToCart = $formContainer.find(settings.addToCartSelector);
    $cartCountSelector = $(settings.cartCountSelector);
    $cartCostSelector = $(settings.cartCostSelector);
    $emptySelector = $(settings.emptySelector);
    $triggerSelector = $(settings.triggerSelector);

    // General Selectors
    $body = $(document.body);

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors();
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    $body.addClass('drawer--is-loading');
    ShopifyAPI.getCart(cartUpdateCallback);
  };

  updateCountPrice = function (cart) {
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function (evt) {
      evt.preventDefault();

      // Add class to be styled if desired
      $(this).find('.js-product-add').removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      ShopifyAPI.addItemFromForm(evt.target, itemAddedCallback, itemErrorCallback);

    });
  };

  itemAddedCallback = function (product) {    
    $addToCart.filter('.is-adding').removeClass('is-adding').addClass('is-added');

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        // CDSD-20606 disable qty error notice
        // $formContainer.after('<div class="errors qty-error">' + data.description + '</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    buildCart(cart);
  };

  function getTotalQuality(input) {
    return input.reduce((prev, current) => {
      if (prev[current.id]) {
        prev[current.id] += current.quantity;
      } else {
        prev[current.id] = current.quantity;
      }
      return prev;
    }, {});
  }
  async function getInventory() {
    const response = await fetch('/cart?view=inventory')
    return response.json().then(data => {return data})
  }
  buildCart = async function (cart) {
    theme.cartJson = cart

    // Start with a fresh cart div
    $cartContainer.empty();
    let $processBar = $('.ajaxcart-draw .congrats-items');

    // Show empty cart
    if (cart.item_count === 0) {
      $processBar.removeClass('active')
      $(settings.emptySelector).show();
      $('body.template-cart').addClass('template-cart--empty');
      $(settings.triggerSelector).removeClass('js-cart-full');
      cartCallback(cart);
      return;
    } else {
      $(settings.emptySelector).hide();
      $('body.template-cart').removeClass('template-cart--empty');
      $(settings.triggerSelector).addClass('js-cart-full');

      // Shipping Free
      let totalPrice = cart.total_price / 100, 
      shippingPrice = parseInt($processBar.attr('data-shipping')),
      $message = $('.title'),
      percent = totalPrice / shippingPrice * 100,
      priceLeft = (shippingPrice - totalPrice) * 100;
      $processBar.addClass('active');
      $('.slider-items .item').css('width', percent+"%");
      $message.removeClass('active');
      $('.total-left').html(Shopify.formatMoney(priceLeft, settings.moneyFormat));
      percent < 100 ? $('.process').addClass('active') : $('.success').addClass('active');
      
      //cart sticky
      $('.mobile-cart-sticky .money').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }

    //Update cart icon in the menu
    $('.js-cart-count').html(cart.item_count);

    //Update cart subtotal
    $('.js-cart-total').html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));

    // Handlebars.js cart layout
    var items = [],
      item = {},
      data = {},
      source = $("#CartTemplate").html(),
      template = Handlebars.compile(source);

    let total = getTotalQuality(cart.items);

    $.each(cart.items, function (index, cartItem) {
      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      if (cartItem.image != null) {
        var prodImg = cartItem.image.replace(/(\.[^.]*)$/, "_192x$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }
      cartItem["total"] = total[cartItem.id];
      var showLineCompare = 'not-sale';
      var lineComparePrice = getCompareAtPrice(cartItem);
      if(lineComparePrice > cartItem.line_price){
        var showLineCompare = 'sale';
      }
      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.price === 0 ? cartItem.url.replace(`variant=${cartItem.variant_id}`,'') : cartItem.url  ,
        img: prodImg,
        name: cartItem.product_title,
        variation: cartItem.variant_title,
        variantId: cartItem.variant_id,
        properties: cartItem.properties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: cartItem.price === 0 ? 'FREE' : Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        freeGift: cartItem.line_price === 0,
        lineComparePrice:  Shopify.formatMoney(lineComparePrice, settings.moneyFormat),
        showLineCompare: showLineCompare,
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        id: cartItem.id,
        quantityInitial: cartItem.quantity,
        outofstock: cartItem.id === productKey && cartItem.discounts[0]?.amount === 0 ? "You exceeded the quantity limit for this item" : "",
        disableOutofstock: cartItem.id === productKey && (cartItem.discounts[0]?.amount === 0 || cartItem.discounts[0]?.amount === undefined),
        maxQuantity: cartItem?.total >= 100
      };
      
      items.push(item);
    });

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      originalTotalPrice: Shopify.formatMoney(cart.original_total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountText: Shopify.formatMoney(cart.total_discount, settings.moneyFormat),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true
    }

    $cartContainer.append(template(data));
    $('.section--cart .ajaxcart__footer-wrapper .congrats-items').prepend($('.ajaxcart-draw .congrats-items').html());
    cartCallback(cart);
    theme.cartInventory = await getInventory()
  };

  getCompareAtPrice = function (cartItem) {
    let compareAtPrice = '',
        show_compareAtPrice = true,
        quantity = cartItem.quantity;

    $.ajax({ 
      url: '/products/' + cartItem.handle + '.js', 
      dataType: 'json',
      async: false, 
      success: function(product){ 
        product.tags.forEach(function(tags) {
          if(tags == "Display:Valued At"){
            show_compareAtPrice = false;
			return false;
          }
        });

        if(show_compareAtPrice){
          product.variants.forEach(function(variant) {
            if(variant.id == cartItem.variant_id){
              if (variant.compare_at_price != null && variant.compare_at_price > variant.price){
                compareAtPrice = variant.compare_at_price*quantity;
				return false;
              }              
            }
          });
        }
      }
    });

    return compareAtPrice;
  };

  cartCallback = function (cart) {
    $body.removeClass('drawer--is-loading');
    $body.trigger('afterCartLoad.ajaxCart', cart);
    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    //Remove item
    $body.on('click', '.ajaxcart-item__remove a', function (e) {
      e.preventDefault();

      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data('line'),
        $qtySelector = 0,
        qty = 0;

      if (line) {
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function () {
      if (isUpdating) {
        return;
      }
      if($('#sca-fg-owl-carousel').length > 0){
        $('#sca-fg-owl-carousel').removeClass('active')
      }
      var $el = $(this),
          line = $el.data("line"),
          $qtySelector = $el.siblings(".ajaxcart__qty-num"),
          id = $el.data("idproduct"),
          quantityInitial = $el.data("quantityInitial"),
          qty = parseInt($qtySelector.val().replace(/\D/g, ""));
      var qty = validateQty(qty);
      var minus = false
      let maxQty = getMaxQty(id),
          $parent = $(this).parents('.product-info')
      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        if (qty - quantityInitial < maxQty) {
          qty += 1;
        } else {
          showMaximumMessage($parent)
        }
      } else {
        qty -= 1;
        minus = true;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        updateQuantity(line, qty, id, quantityInitial, minus);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function () {
      if (isUpdating) {
        return;
      }
      var $el = $(this),
        line = $el.data("line"),
        id = $el.data("idproduct"),
        quantityInitial = $el.data("quantityInitial"),
        total = $el.data("total"),
        $parent = $(this).parents('.product-info'),
        qty = parseInt($el.val().replace(/\D/g, ""));
      const variantId = parseInt(id)
      var qty = validateQty(qty);
      let max = ajaxCart.getMaxQty(id)
      let addQty = qty - quantityInitial
      if(theme.cartInventory[variantId].policy !== "continue" && qty > theme.cartInventory[variantId].quantity) {
        qty = theme.cartInventory[variantId].quantity
        ajaxCart.showMaximumMessage($parent,'You exceeded the limit for this product.')
      } else if(total + addQty > max && qty > quantityInitial) {
        qty = max + quantityInitial
        ajaxCart.showMaximumMessage($parent,'The maximum purchasable quantity is 100')
      }

      if (line) {
        updateQuantity(line, qty, id, quantityInitial);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function (evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function () {
      var $el = $(this);
      setTimeout(function () {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty, id = null, quantityInitial = null, minus = false) {
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }
      // Slight delay to make sure removed animation is done
      setTimeout(function () {
        ShopifyAPI.changeItemCart(line, qty, id, quantityInitial, minus, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function () {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote, function (cart) { });
    });
  };

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);
    
    // Reprint cart on short timeout so you don't see the content being removed
    setTimeout(function () {
      isUpdating = false;
      ShopifyAPI.getCart(buildCart);
    }, 150)
  };

  createQtySelectors = function () {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartContainer).length) {
      $('input[type="number"]', $cartContainer).each(function () {
        var $el = $(this),
          currentQty = $el.val();

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#AjaxQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
    }
  };
  getMaxQty = function (variantID) {
    let qtyItemAdded = getQtyAdded(variantID)
    const max = 100
    return max - qtyItemAdded
  }
  getQtyAdded = function (variantID){
    let qtyItemAdded = 0
    theme.cartJson.items.map((item) => {
      if(item.id == variantID) {
        qtyItemAdded += item.quantity
      }
    })
    return qtyItemAdded
  }
  showMaximumMessage = function ($container,message) {
    const $messageEl = $container.find('.outofstock_class')
    $container.addClass('error')
    $container.find('.wrap__outofstock').addClass('show')
    if(message) {
      $messageEl.html(message)
    }
    setTimeout(()=>{
      $container.removeClass('error')
      $container.find('.wrap__outofstock').removeClass('show')
      $('.js-product-add.is-adding').removeClass('is-adding')
    },2000)
  }
  qtySelectors = function () {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function () {
        var $el = $(this),
          currentQty = $el.val(),
          inputName = $el.attr('name'),
          inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
          itemMinus = currentQty - 1,
          itemQty = currentQty;

        var source = $("#JsQty").html(),
          template = Handlebars.compile(source),
          data = {
            key: $el.data('id'),
            itemQty: itemQty,
            itemAdd: itemAdd,
            itemMinus: itemMinus,
            inputName: inputName,
            inputId: inputId
          };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });
      $('.js-qty__num').on('change', function () {
        const $parent = $(this).parents('.product-single__form')
        const variantID = $parent.find('[name="id"]').val()
        const maxQty = getMaxQty(variantID)
        const inventory = parseInt(window.productInventory)
        const itemAdded = getQtyAdded(variantID)
        const val = parseInt($(this).val())
        if (val > 100) {
          showMaximumMessage($parent, 'The maximum purchasable quantity is 100')
          $(this).val(100)
        } else if (val + itemAdded > inventory) {
          $(this).val(inventory - itemAdded)
          showMaximumMessage($parent, 'You exceeded the quantity limit for this item')
        } else if (val > maxQty) {
          $(this).val(maxQty > 0 ? maxQty : 1)
          showMaximumMessage($parent, 'The maximum purchasable quantity is 100')
        }
      })
      // Setup listeners to add/subtract from the input
      $('.js-qty__adjust').on('click', function () {
        const $parent = $(this).parents('.product-single__form')
        var $el = $(this),
          id = $el.data('id'),
          $qtySelector = $el.siblings('.js-qty__num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        const variantID = $(this).parents('.product-single__form').find('[name="id"]').val()
        const maxQty = getMaxQty(variantID)
        const inventory = parseInt(window.productInventory)
        const itemAdded = getQtyAdded(variantID)
        var qty = validateQty(qty);

        // Add or subtract from the current quantity
        if ($el.hasClass('js-qty__adjust--plus')) {
          if(qty + 1 > inventory - itemAdded){
            showMaximumMessage($parent,'You exceeded the quantity limit for this item')
          } else if (qty < maxQty) {
            qty += 1;
          } else {
            showMaximumMessage($parent,'The maximum purchasable quantity is 100')
          }
        } else {
          qty -= 1;
          if (qty <= 1) qty = 1;
        }

        // Update the input's number
        $qtySelector.val(qty);
      });
    }
  };

  validateQty = function (qty) {
    if ((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 1.
      qty = 1;
    }
    return qty;
  };

  module = {
    init: init,
    load: loadCart,
    itemAddedCallback: itemAddedCallback,
    showMaximumMessage: showMaximumMessage,
    getMaxQty: getMaxQty
  };

  return module;

}(ajaxCart || {}, jQuery));
